import { useEffect, useState } from 'react';
import styles from '../FormularioPeriodo/index.scss';
import { getPropsToLabelColaboradores } from 'utils/HelpButtonUtils';
import HelpButtonEditEscola from 'components/HelpButton/HelpButtonEditEscola/HelpButtonEditEscola';
import { Container } from '@material-ui/core';
import SnackbarUtils from 'utils/SnackbarUtils';
import { isAuthorizedRequest } from 'utils/httpResponseHandlers';
import { getElementID } from 'utils/HTMLUtils';
import { Col } from 'components/Col';
import { CustomCard } from 'components/CustomCard';
import { NewAutoCompleteField } from 'components/NewAutoCompleteField';
import { Row } from 'components/Row';
import { CustomNumberField } from 'components/CustomNumberField';
import { UnauthorizedScreen } from 'components/UnauthorizedScreen';
import { changePeriodoEditingValue, clearPeriodoEditing, loadPeriodoByIdAndPeriodo, loadPeriodosById, savePeriodo, setEnviarFormularioPeriodo } from 'store/modules/EscolasActions';
import { useDispatch, useSelector } from 'react-redux';
import './index.scss'
import useProgramas from 'pages/Escola/Cadastro/etapas/ProgramasEducacionais/hooks/useProgramas';
import useValidationFields from 'pages/Escola/Cadastro/etapas/ProgramasEducacionais/hooks/useValidationFields';
import { useAtualizarPeriodoAtualDuplicacao } from 'pages/Escola/Cadastro/etapas/ProgramasEducacionais/hooks/usePeriodo';
import { TipoPrograma } from 'store/modules/EscolasTypes';

const rootClassName = styles.rootClassName;
const rootElementId = 'form-uniao-faz-vida';

const INITIAL_STATE = {
  authorizedRequest: true,
  sending: false,
  loading: false,
  edInfantilProfChanged: false,
  edInfantilAlunChanged: false,
  ensFundIProfChanged: false,
  ensFundIAlunChanged: false,
  ensFundIIProfChanged: false,
  ensFundIIAlunChanged: false,
  ensMedioProfChanged: false,
  ensMedioAlunChanged: false,
  ejaProfChanged: false,
  ejaAlunChanged: false,
  especializadaProfChanged: false,
  especializadaAlunChanged: false,
  loadingPeriodos: true,
};
const FormDadosPufv = ({ id, periodo, onRefresh, formKey }) => {
  const [state, setState] = useState(INITIAL_STATE);
  const periodoKey = 'periodoEditing'
  const escolas = useSelector((escolasState) => escolasState.escolas);
  const { retornaListaPeriodos, useTituloModal } = useProgramas();
  const languageValues = useSelector((languageState) => languageState.languages.languageValues);
  const auth = useSelector((authState) => authState.auth);
  const { errors, formIsValid, processing } = useValidationFields(escolas, languageValues, periodoKey)
  const enviarFormulario = useSelector((stateReducer) => stateReducer.escolas.enviarFormularioPeriodo);
  const duplicacaoPeriodo = formKey === "duplicar"
  const dispatch = useDispatch();

  const tituloModal = useTituloModal(formKey, TipoPrograma.UniaoFazAVida);

  const loadPeriodo = () => {
    setState((prevState) => ({ ...prevState, loading: true }));
    dispatch(
      loadPeriodoByIdAndPeriodo(
        id,
        periodo,
        () => {
          setState((prevState) => ({
            ...prevState,
            loading: false,
            edInfantilProfChanged: true,
            edInfantilAlunChanged: true,
            ensFundIProfChanged: true,
            ensFundIAlunChanged: true,
            ensFundIIProfChanged: true,
            ensFundIIAlunChanged: true,
            ensMedioProfChanged: true,
            ensMedioAlunChanged: true,
            ejaProfChanged: true,
            ejaAlunChanged: true,
            especializadaProfChanged: true,
            especializadaAlunChanged: true,
          }));
          loadPeriodos();
        },
        (error) => {
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText ||
              languageValues.errorLoadPeriodoEditing,
            options: {
              variant: 'error',
            },
          });
        }
      )
    );
  };

  const loadPeriodos = () => {
    dispatch(
      loadPeriodosById(
        id,
        () => {
          setState((prevState) => ({ ...prevState, loadingPeriodos: false }));
        },
        (error) => {
          SnackbarUtils.enqueueSnackbar({
            message:
              error.response.statusText ||
              languageValues.errorLoadPeriodosList,
            options: {
              variant: 'error',
            },
          });
        }
      )
    );
  };

  const editing = () => {
    return periodo && periodo.length > -1;
  };

  const setValue = (event) => {
    const cuttedName = event.target.name
      .split('Prof')
      .join('')
      .split('Alun')
      .join('');
    let value;
    if (event.target.value === '') {
      value = '';
    } else {
      value = [
        'edInfantil',
        'ensFundI',
        'ensFundII',
        'ensMedio',
        'eja',
        'especializada',
      ].indexOf(cuttedName) > -1
        ? Number(event.target.value)
        : event.target.value;
    }
    setState((prevState) => ({
      ...prevState,
      [event.target.name + 'Changed']: true,
    }));
    dispatch(changePeriodoEditingValue(event.target.name, value));
  };

  const mensagemEnvio = () => {
    switch (true) {
      case duplicacaoPeriodo:
        return languageValues.successDuplicarPeriodo;
      case editing():
        return languageValues.successSalvarPeriodo;
      default:
        return languageValues.successCadastrarPeriodo;
    }
  };

  const toSubmit = () => {
    if (!formIsValid()) {
      return;
    }

    const replaceEmptyWithZero = Object.entries(escolas.periodoEditing).reduce(
      (acc, [key, value]) => ({ ...acc, [key]: value === '' ? 0 : value }),
      {}
    );

    setState((prevState) => ({ ...prevState, sending: true }));
    const periodoValues = {
      periodo: replaceEmptyWithZero.periodo,
      colaboradores: replaceEmptyWithZero.colaboradores,
      idEscola: replaceEmptyWithZero.id || id,
      edInfantilProf: replaceEmptyWithZero.edInfantilProf,
      edInfantilAlun: replaceEmptyWithZero.edInfantilAlun,
      ensFundIProf: replaceEmptyWithZero.ensFundIProf,
      ensFundIAlun: replaceEmptyWithZero.ensFundIAlun,
      ensFundIIProf: replaceEmptyWithZero.ensFundIIProf,
      ensFundIIAlun: replaceEmptyWithZero.ensFundIIAlun,
      ensMedioProf: replaceEmptyWithZero.ensMedioProf,
      ensMedioAlun: replaceEmptyWithZero.ensMedioAlun,
      ejaProf: replaceEmptyWithZero.ejaProf,
      ejaAlun: replaceEmptyWithZero.ejaAlun,
      especializadaProf: replaceEmptyWithZero.especializadaProf,
      especializadaAlun: replaceEmptyWithZero.especializadaAlun,
    };
    dispatch(
      savePeriodo(
        periodoValues,
        () => {
          SnackbarUtils.enqueueSnackbar({
            message: mensagemEnvio(),
            options: {
              variant: 'success',
            },
          });
          setState((prevState) => ({ ...prevState, sending: false }));
          retornaListaPeriodos(id, TipoPrograma.UniaoFazAVida, true);
          onRefresh()
        },
        (error) => {
          if (isAuthorizedRequest(error.response)) {
            SnackbarUtils.enqueueSnackbar({
              message:
                error.response.statusText ||
                (editing() && !duplicacaoPeriodo
                  ? languageValues.erroSalvarPeriodo
                  : languageValues.erroCadastrarPeriodo),
              options: {
                variant: 'error',
              },
            });
            setState((prevState) => ({ ...prevState, sending: false }));
          } else {
            setState((prevState) => ({
              ...prevState,
              sending: false,
              authorizedRequest: false,
            }));
          }
          retornaListaPeriodos(id, TipoPrograma.UniaoFazAVida, true);
          onRefresh()
        }
      )
    );
  };

  const getCompletedLabels = (isProf) => {
    return [
      languageValues['educacaoInfantil' + (isProf ? 'Prof' : 'Alun') + 'Label'],
      languageValues[
      'ensinoFundamentalI' + (isProf ? 'Prof' : 'Alun') + 'Label'
      ],
      languageValues[
      'ensinoFundamentalII' + (isProf ? 'Prof' : 'Alun') + 'Label'
      ],
      languageValues['ensinoMedio' + (isProf ? 'Prof' : 'Alun') + 'Label'],
      languageValues['eja' + (isProf ? 'Prof' : 'Alun') + 'Label'],
      languageValues[
      'escolaEspecializada' + (isProf ? 'Prof' : 'Alun') + 'Label'
      ],
    ];
  };

  const getValueTypes = () => {
    return [
      'edInfantil',
      'ensFundI',
      'ensFundII',
      'ensMedio',
      'eja',
      'especializada',
    ];
  };

  const getPeriodos = () => {
    return escolas.periodoEditing.periodosList.map((p) => ({
      value: p.nomPeriodo,
      label: p.nomPeriodo.split('-').join('/'),
      disabled: (!editing() || duplicacaoPeriodo) ? p.flgStatus > 0 : false,
    }));
  };

  useAtualizarPeriodoAtualDuplicacao(duplicacaoPeriodo, 'pufv');

  useEffect(() => {
    if (editing()) {
      if (auth.userPermissions.escolas.dadosDaEscola.edit) {
        loadPeriodo();
      } else {
        setState((prevState) => ({ ...prevState, authorizedRequest: false }));
      }
    } else {
      if (auth.userPermissions.escolas.dadosDaEscola.register) {
        loadPeriodos();
      } else {
        setState((prevState) => ({ ...prevState, authorizedRequest: false }));
      }
    }
    return () => {
      dispatch(clearPeriodoEditing());
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, id, periodo, auth, languageValues]);

  useEffect(() => {
    if (enviarFormulario) {
      toSubmit();
      dispatch(setEnviarFormularioPeriodo(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enviarFormulario, dispatch]);

  return state.authorizedRequest ? (
    <Container
      style={{
        marginTop: 0,
        padding: 0
      }}>
      <CustomCard
        CardPropTypes={{
          className:
            rootClassName + '-card'
        }}
        CardHeaderPropTypes={{
          title: (
            <div className="custom-title-wrapper">
              <span className="custom-title-text">
                {`${tituloModal} de dados do ano do programa A União Faz a Vida`}
              </span>
              <span className="custom-title-sub">
                Informe os dados anuais do programa
              </span>
            </div>
          )
        }}
        titleHint={languageValues.dadosDaEscolaEditHint}
        sending={state.sending || state.loading}
      >
        <form
          onSubmit={(event) => {
            event.preventDefault();
            toSubmit();
          }}
        >
          <Row>
            <Col cols={[12, 6, 6, 6, 6]}>
              <NewAutoCompleteField
                id={getElementID(rootElementId, 'periodo')}
                label={languageValues.ano}
                placeholder={
                  escolas.periodoEditing.loadingPeriodosList
                    ? languageValues.loadingPeriodos
                    : 'Selecionar o Ano'
                }
                options={getPeriodos()}
                value={escolas.periodoEditing.periodo || ''}
                onChange={(value) => {
                  const currValue = value && value.value > '' ? value.value : '';
                  setValue({
                    target: {
                      name: 'periodo',
                      value: currValue,
                    },
                  });
                }}
                loading={escolas.periodoEditing.loadingPeriodosList}
                loadingMessage={languageValues.loadingPeriodos}
                disabled={(editing() || duplicacaoPeriodo || processing() || state.loadingPeriodos)}
              />
            </Col>

            <Col cols={[12, 6, 6, 6, 6]}>
              <CustomNumberField
                id={getElementID(rootElementId, 'colaboradores')}
                disabled={processing()}
                onlyInteger={true}
                onlyPositive={true}
                label={
                  <>
                    {languageValues.colaboradores}
                    <HelpButtonEditEscola
                      text={languageValues.hintColaboradoresEscolaEdit}
                      {...getPropsToLabelColaboradores()}
                    />
                  </>
                }
                name={'colaboradores'}
                value={escolas.periodoEditing.colaboradores}
                onChange={setValue}
                onBlur={(event) => {
                  if (event.target.value === '') {
                    setValue({ target: { name: event.target.name, value: 0 } });
                  }
                }}
              />
            </Col>
          </Row>
          {getValueTypes().map((type, index) => {
            const isEscolaEspecializadaProfLabel =
              type === 'especializada' && 'isProf';

            return (
              <Row key={index}>
                <Col cols={[12, 6, 6, 6, 6]}>

                  <CustomNumberField
                    id={getElementID(rootElementId, type + '-professor')}
                    disabled={processing()}
                    onlyInteger={true}
                    onlyPositive={true}
                    label={
                      <>
                        {getCompletedLabels(true)[index]}
                        {isEscolaEspecializadaProfLabel && (
                          <HelpButtonEditEscola
                            text={languageValues.hintEducacaoInfantilProfLabel}
                            {...getPropsToLabelColaboradores()}
                          />
                        )}
                      </>
                    }
                    name={type + 'Prof'}
                    value={escolas.periodoEditing[type + 'Prof']}
                    onChange={setValue}
                    onBlur={(event) => {
                      if (event.target.value === '') {
                        setValue({ target: { name: event.target.name, value: 0 } });
                      }
                    }}
                    error={errors[type + 'Prof']}
                  />
                  {errors[type + 'Prof'] && (
                    <div className="error-message">
                      {errors[type + 'Prof']}
                    </div>
                  )}
                </Col>
                <Col cols={[12, 6, 6, 6, 6]}>
                  <CustomNumberField
                    id={getElementID(rootElementId, type + '-aluno')}
                    disabled={processing()}
                    onlyInteger={true}
                    onlyPositive={true}
                    label={getCompletedLabels()[index]}
                    name={type + 'Alun'}
                    value={escolas.periodoEditing[type + 'Alun']}
                    onChange={setValue}
                    onBlur={(event) => {
                      if (event.target.value === '') {
                        setValue({ target: { name: event.target.name, value: 0 } });
                      }
                    }}
                    error={errors[type + 'Alun']}
                  />
                  {errors[type + 'Alun'] && (
                    <div className="error-message">
                      {errors[type + 'Alun']}
                    </div>
                  )}
                </Col>
              </Row>
            );
          })}
        </form>
      </CustomCard>
    </Container >
  ) : (
    <UnauthorizedScreen />
  );
};

export default FormDadosPufv
